// public models

import { OrganizationRoleTypes } from 'src/app/store/user/user.enum';
import { SortOrder } from 'studio-components';

export interface Organization {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  datetimeAdded: string;
  datetimeModified: string;
  organizationType: string;
}

export interface OrganizationConfig {
  deploymentSubdomain: string;
}

// Admin models

export interface AdminOrganization {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  attributes?: any;
  datetimeAdded: string;
  datetimeDeleted: string;
  datetimeModified: string;
  organizationType: string;
  stripeSubscriptionId: string | null;
}

export type AdminOrganizationQuery = {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
  sortOrder?: SortOrder;
  orderBy?: AdminOrganizationOrderByKey;
  search?: string;
};

export interface AdminOrganizationsWithMetadata {
  metadata: {
    includeDeleted: boolean;
    page: number;
    limit: number;
    total: number;
    orderBy: AdminOrganizationOrderByKey;
    sortOrder: SortOrder;
    ids?: string;
    search?: string;
  };
  data: AdminOrganization[];
}

export interface AdminOrganizationConfigValues {
  // google tts api
  GoogleTtsApiKey: string;
  // amazon tts
  AmazonPollyTtsAccessKeyId: string;
  AmazonPollyTtsSecretKey: string;
  AmazonPollyTtsRegion: string;
  // microsoft tts
  MicrosoftTtsTokenServiceEndpoint: string;
  MicrosoftTtsApiKey: string;
  MicrosoftTtsEndpoint: string;
  // Watson NLP *can we have ones that can be overwritten by user?
  WorkspaceUser: string;
  WorkspacePassword: string;
  // Dialogflow
  DialogflowServiceAccount: Record<string, unknown>;
}

export interface AdminOrganizationConfig {
  id: number;
  organizationId: number;
  defaultDomain: string;
  deploymentSubdomain: string | null;
  values: AdminOrganizationConfigValues;
}

export interface AdminOrganizationAttrsValues {
  avatars: {
    include: string[];
  };
}

export interface AdminOrganizationAttrs {
  id: number;
  organizationId: number;
  values: AdminOrganizationAttrsValues;
}

// shared models

// auth0 user model
// https://auth0.com/docs/users/references/user-profile-structure
// our api does not translate any fields
// these are not all but just a few useful fields for UI
export interface OrganizationMetadata {
  organizationId: number;
  organizationName: string;
  organizationDisplayName: string;
  organizationRoles: string[];
  organizationType: string;
}

export type OrganizationAccesses = {
  [key: string]: OrganizationMetadata;
};

export enum OrganizationInvitationStatus {
  Sent = 'sent',
  Accepted = 'accepted',
}

interface OrganizationInvitation {
  status: OrganizationInvitationStatus;
  organizationId: number;
  organizationRoles: string[];
  sentBy: string;
  sentDate: string;
  acceptedDate?: string;
}

export type OrganizationInvitations = {
  [key: string]: OrganizationInvitation;
};

export interface AdminOrganizationUser {
  created_at: string;
  updated_at: string;
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  name: string;
  user_id: string;
  last_login: string;
  logins_count: number;
  app_metadata: {
    soulmachines: OrganizationMetadata;
    organizationAccesses?: OrganizationAccesses;
  };
  user_metadata?: {
    invitations?: OrganizationInvitations;
  };
  organizationRoles?: OrganizationRoleTypes;
  blocked?: boolean;
}

export interface OrganizationUsersResult {
  users: AdminOrganizationUser[];
  total: number;
  length: number;
  start: number;
  limit: number;
}

export type AdminOrganizationOrderByKey = keyof Pick<
  AdminOrganization,
  'id' | 'name' | 'displayName' | 'datetimeAdded' | 'datetimeModified'
>;
